import { ADMIN_API_BASE } from '../../callApi'
import { schema } from './user'

import { CallApi } from '@signavio/kraken'

export { collection, schema } from './user'

type CreateQueryType = {
  userId: string
  organizationId: string
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  (
    { admin }: { admin: boolean },
    { userId, organizationId }: CreateQueryType
  ) => {
    if (admin) {
      return callApi(`${ADMIN_API_BASE}/users/${userId}/leave`, schema, {
        method: 'POST',
        body: {
          organizationId,
        },
      })
    }
    return callApi(`${apiBase}/users/${userId}/leave`, schema, {
      method: 'POST',
      body: {
        organizationId,
      },
    })
  }
